document.addEventListener('DOMContentLoaded',function(){
  /* Scroll reveal */
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('wc26-show');obs.unobserve(e.target)}})},{threshold:.1});
    document.querySelectorAll('.wc26-fade-up').forEach(function(el){obs.observe(el)});
  }else{document.querySelectorAll('.wc26-fade-up').forEach(function(el){el.classList.add('wc26-show')})}

  /* Countdown */
  var cdEl=document.getElementById('wc26-countdown');
  if(cdEl){
    var target=new Date(cdEl.dataset.target||'2026-06-11T16:00:00-04:00');
    function tick(){
      var d=Math.max(0,target-new Date());
      var vals={days:Math.floor(d/864e5),hrs:Math.floor((d%864e5)/36e5),min:Math.floor((d%36e5)/6e4),sec:Math.floor((d%6e4)/1e3)};
      cdEl.querySelectorAll('[data-unit]').forEach(function(el){
        var v=vals[el.dataset.unit];
        if(v!==undefined)el.querySelector('.wc26-countdown__num').textContent=String(v).padStart(2,'0');
      });
    }
    tick();setInterval(tick,1000);
  }

  /* Jersey picker */
  var picker=document.getElementById('wc26-jersey-picker');
  if(picker){
    var shirt=picker.querySelector('.wc26-tshirt-body');
    var collar=picker.querySelector('.wc26-tshirt-collar');
    var detail=picker.querySelector('.wc26-tshirt-detail');
    var txt26=picker.querySelector('text');
    var nameFlag=picker.querySelector('.wc26-jersey__name-flag');
    var nameText=picker.querySelector('.wc26-jersey__name-text');
    var shirtWrap=picker.querySelector('.wc26-jersey__shirt');
    var chips=picker.querySelectorAll('.wc26-flag-chip');

    chips.forEach(function(chip){
      chip.addEventListener('click',function(){
        chips.forEach(function(c){c.classList.remove('wc26-active')});
        chip.classList.add('wc26-active');
        var c=chip.dataset.color,a=chip.dataset.accent;
        if(shirt){shirt.style.fill=c;shirt.style.stroke=a}
        if(collar)collar.style.stroke=a;
        if(detail)detail.style.stroke=a;
        if(txt26)txt26.style.fill=a;
        if(nameFlag)nameFlag.textContent=chip.dataset.flag;
        if(nameText)nameText.textContent=chip.dataset.name.toUpperCase();
        if(shirtWrap)shirtWrap.style.filter='drop-shadow(0 8px 50px '+c+'40)';
      });
    });
  }
});
